import { z } from 'zod'

/***************** 인쇄 분할 *****************/
// 한 면에 문제를 몇 칸으로 나눠 싣는지. 서버는 enum 없이 Int 로 받고 허용값을 요청마다 설명으로만 적는다
// (학습지 만들기는 0~16, 교재·디자인은 0·2·4·6). 8 이상은 연산 학습지의 고밀도 분할이다.
export const PARTITION_TYPE = [0, 2, 4, 6, 8, 10, 12, 14, 16] as const

/***************** 인쇄 색상 *****************/
// 서버 BookColorType. 학습지·교재 인쇄물과 HWP 의 강조 색
export const LAYOUT_COLOR = [
  'BLUE',
  'ORANGE',
  'CRUSTA',
  'PINK',
  'SAPPHIRE',
  'GREEN',
  'JUNGLE_GREEN',
  'GRAY',
] as const

/***************** 인쇄 날짜 표기 *****************/
export const PDF_DATE_TYPE = ['NONE', 'TODAY', 'CUSTOM'] as const

/***************** 인쇄물 파일 업로드 결과 *****************/
export const PRINT_DOCUMENT_FILE_UPLOAD_STATUS = ['SUCCESS', 'FAILURE'] as const

export const PartitionTypeSchema = z.literal(PARTITION_TYPE)
export type PartitionType = z.infer<typeof PartitionTypeSchema>

export const LayoutColorSchema = z.enum(LAYOUT_COLOR)
export type LayoutColor = z.infer<typeof LayoutColorSchema>

export const PdfDateTypeSchema = z.enum(PDF_DATE_TYPE)
export type PdfDateType = z.infer<typeof PdfDateTypeSchema>

export const PrintDocumentFileUploadStatusSchema = z.enum(PRINT_DOCUMENT_FILE_UPLOAD_STATUS)
export type PrintDocumentFileUploadStatus = z.infer<typeof PrintDocumentFileUploadStatusSchema>

/** 인쇄물(맞춤 인쇄) 한 건. 게시 상태(status)는 앱이 읽지 않아 받지 않는다 */
export const PrintDocumentSchema = z.object({
  id: z.number(),
  // 파일 업로드가 끝나기 전이나 실패하면 null 이다
  fileKey: z.string().nullable(),
  thumbnailImageKey: z.string().nullable(),
})
export type PrintDocument = z.infer<typeof PrintDocumentSchema>

/** 인쇄물 생성 결과. 앱은 이 URL 로 PDF 를 직접 올린 뒤 업로드 결과를 알린다 */
export const PrintDocumentCreationSchema = z.object({
  printDocumentId: PrintDocumentSchema.shape.id,
  printDocumentFilePresignedUrl: z.string(),
})
export type PrintDocumentCreation = z.infer<typeof PrintDocumentCreationSchema>
